module.exports = "/legacy/b9ab156983f44890fbb043d9071393a0.png";